import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './index.css'
import './lib/i18n'
import { InvalidateOnLanguageChange } from './lib/InvalidateOnLanguageChange'

// Una pestaña abierta durante un deploy tiene el index viejo en memoria: al
// navegar pide chunks que ya no existen y la pantalla quedaba en blanco
// (15-10). Vite avisa con `vite:preloadError`; se recarga UNA vez para traer el
// index nuevo. La marca en sessionStorage evita un bucle si el chunk falta de
// verdad.
window.addEventListener('vite:preloadError', (event) => {
  const marca = 'aldo:recargado-por-chunk'
  try {
    if (sessionStorage.getItem(marca)) return
    sessionStorage.setItem(marca, '1')
  } catch {
    return
  }
  event.preventDefault()
  window.location.reload()
})
window.addEventListener('load', () => {
  // Si la recarga anduvo, la próxima falla puede volver a recargar.
  setTimeout(() => {
    try { sessionStorage.removeItem('aldo:recargado-por-chunk') } catch { /* sin storage */ }
  }, 10_000)
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <InvalidateOnLanguageChange />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)

